const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const apiCall = async (endpoint, options = {}) => {
  const token = localStorage.getItem('auth_token');
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  const response = await fetch(`${API_URL}${endpoint}`, config);
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || error.message || `API call failed: ${response.status}`);
  }
  return response.json();
};

export const fetchCurrentUser = async () => {
  return apiCall('/api/auth/me');
};

export const fetchMysteryBootstrap = async () => {
  return apiCall('/api/mystery-client/bootstrap');
};

export const fetchMysteryComparison = async () => {
  return apiCall('/api/mystery-client/comparison');
};
